





























































































import {
  defineComponent,
  computed,
  reactive,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import productGroupTableList from '@/table/product/productGroup';
import useAuth from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import getProductGroups from '@/gql/product/getProductGroups.gql';
import createProductGroup from '@/gql/product/createProductGroup.gql';
import updateProductGroup from '@/gql/product/updateProductGroup.gql';

const CreateProductType = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
  },
  setup() {
    const { me } = useAuth();
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const { router } = useRouter();
    const addProductTypeModal = ref(null);
    const updateProductTypeModal = ref(null);
    const onRowClick = (row: any) => {
      // router.push({ name: 'DeliveryInformation', params: { id: row.item.id } });
    };

    const confirmModal = ref(null);
    const errorModal = ref(null);

    const filter = reactive({
      productGroupName: undefined,
      productGroupId: undefined,
      search: undefined,
    });

    const handleEditClick = (groupName: any, id: any) => {
      (updateProductTypeModal.value as any).open();
      filter.productGroupName = groupName;
      filter.productGroupId = id;
    };
    const handleAddProductGroupClick = () => {
      (addProductTypeModal.value as any).open();
      filter.productGroupName = undefined;
      filter.productGroupId = undefined;
    };

    const computedFilterVariables = computed(() => {
      const vars: { name: string | undefined } = {
        name: undefined,
      };
      if (filter.search) vars.name = `%${filter.search}%`;
      return vars;
    });
    const { result: productGroupsDetail } = useQuery(getProductGroups);
    const getTotalProductGroupsNumber = computed(() => productGroupsDetail.value?.productGroups?.paginatorInfo?.total || 0);

    const getProductGroupsResult = (data: any) => data.productGroups;
    const createProductGroupMutation = useMutation(createProductGroup, computed(() => ({
      variables: {
        data: { name: filter.productGroupName },
      },
      refetchQueries: ['getProductGroups'],
    })));
    createProductGroupMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'การเพิ่มประเภทสินค้า สำเร็จ' });
      (addProductTypeModal.value as any).close();
    });
    createProductGroupMutation.onError(() => {
      (errorModal.value as any).compose();
    });

    const updateProductGroupMutation = useMutation(updateProductGroup, computed(() => ({
      variables: {
        data: { name: filter.productGroupName, id: filter.productGroupId },
      },
      refetchQueries: ['getProductGroups'],
    })));
    updateProductGroupMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'การแก้ไขประเภทสินค้า สำเร็จ' });
      (updateProductTypeModal.value as any).close();
    });
    updateProductGroupMutation.onError(() => {
      (errorModal.value as any).compose();
    });

    return {
      me,
      toCurrency,

      filter,
      computedFilterVariables,

      onRowClick,
      handleEditClick,
      handleAddProductGroupClick,

      getProductGroups,
      getProductGroupsResult,
      productGroupTableList,

      createProductGroup,
      createProductGroupMutation,

      updateProductGroup,
      updateProductGroupMutation,

      getTotalProductGroupsNumber,

      addProductTypeModal,
      updateProductTypeModal,

      confirmModal,
      errorModal,
    };
  },
});

export default CreateProductType;
